import Papa from 'papaparse';

import { ExportColumn } from '~utils/export/exportColumn';

export function toCsv<T>(rows: T[], columns: ExportColumn<T>[]) {
  const csv = Papa.unparse({
    fields: columns.map((column) => column.header),
    data: rows.map((row) => columns.map((column) => column.get(row))),
  });
  return rows.length === 0 ? csv.replace(/\r?\n$/, '') : csv;
}

// Same anchor-click idiom as downloadCsvFile, generalized to any Blob so CSV and PDF
// share one download path. The created object URL is always revoked to avoid a leak.
export function downloadBlobFile(blob: Blob, filename: string) {
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
